import { type I18nLocale } from '@ardoq/i18n';
import { BrowseReferencesInteractiveRow } from './BrowseReferencesInteractiveRow';
import {
  ReferenceInteractiveTopRowCommands,
  ReferenceInteractiveTopRowState,
} from './types';

export type ReferenceInteractiveTopRowProps = {
  state: ReferenceInteractiveTopRowState;
  commands: ReferenceInteractiveTopRowCommands;
  i18nLocale: I18nLocale;
};

export const ReferenceInteractiveTopRow = ({
  state,
  commands,
  i18nLocale,
}: ReferenceInteractiveTopRowProps) => {
  switch (state.mode) {
    case 'browseReferences':
      return (
        <BrowseReferencesInteractiveRow
          commands={commands}
          i18nLocale={i18nLocale}
        />
      );
    default:
      state.mode satisfies never;
      return null;
  }
};
